/**
 * React Query hook for single issue details
 */

import { useQuery } from '@tanstack/react-query'
import { useIssueRepository } from '../IssueRepositoryContext'
import { useExperienceMode } from '../../context/ExperienceModeContext'

export function useIssueDetails(issueId: string | null) {
  const repository = useIssueRepository()
  const { experienceMode } = useExperienceMode()

  return useQuery({
    queryKey: ['issueDetails', experienceMode, issueId],
    queryFn: () => repository.getIssueDetails(issueId!),
    enabled: !!issueId,
    staleTime: 30_000,
  })
}
